import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { ButtonWrapper } from '../global/components/layout/button-wrapper';
import { TcsmModal } from '../global/components/tcsm-modal';
import { WysiwygWithReactLink } from '../global/components/wysiwyg-with-react-link';
import { buttonStyles } from '../global/constants/theme/styles/components/buttonstyles';
import { useBasePath } from '../global/hooks/useBasePath';
import { ExternalLinkState } from '../global/models/app-context-model';
import { ArcRoutes } from '../pages/arc/constants/routes';
import { CicSettings } from '../pages/arc/features/cic-opt/model';
import { TcsmStates } from '../root/tcsm-model';

interface Props {
	handleClose: () => void,
	clientId: string,
}
export function CicElectronicAgreementModal(props: Props) {
	const { handleClose, clientId } = props;

	const settings = useSelector<TcsmStates, CicSettings>(state => state?.epiProps?.cicSettingsState?.epiContent);
	const externalLinkState = useSelector<TcsmStates, ExternalLinkState>(state => state.appContext?.externalLinkState);
	const buttonClasses = buttonStyles();
	const [content, setContent] = useState({ title: settings?.optInModalTitle, content: settings?.optInModalContent });
	const [moreInfoState, setMoreInfoState] = useState(false);
	const history = useHistory();

	const moreInfoOnClick = () => {
		if (!moreInfoState) {
			setContent({ title: settings?.optInMoreInfoModalTitle, content: settings?.optInMoreInfoModalContent });
			setMoreInfoState(true);
			return;
		}
		handleClose();
	};

	const optInFormPath = useBasePath(ArcRoutes.CicOptInForm);

	const affirmOnClick = () => {
		handleClose();
		history.push({
			pathname: optInFormPath,
			state: {
				clientId,
				returnUrl: history.location.pathname,
			},
		});
	};

	return (

		<TcsmModal
			open={externalLinkState?.renderModal}
			handleClose={handleClose}
		>
			<h2 className='modal-content-title'>{content?.title}</h2>
			<WysiwygWithReactLink content={content?.content} />
			<ButtonWrapper flexEnd>
				<button type='button' className={buttonClasses.tertiaryButton} onClick={moreInfoOnClick} >{moreInfoState ? settings?.optInMoreInfoDeclineButtonText : settings?.optInMoreInfoButtonText}</button>
				<button type='button' className={buttonClasses.primaryButton} onClick={affirmOnClick} >{settings?.optInAffirmButtonText}</button>
			</ButtonWrapper>
		</TcsmModal>
	);
}
